import React, { Component } from "react";
import { Box, Text, Grommet } from "grommet";

const printTheme = {
  global: {
    font: {
      family: "Arial, sans-serif",
      size: "12px",
    },
    colors: {
      text: {
        dark: "#000000",
        light: "#000000",
      },
    },
  },
};

class PrintCustomerList extends Component {
  render() {
    const { customers } = this.props;
    
    // Sort customers by fullname alphabetically
    const sortedCustomers = [...customers].sort((a, b) => 
      a.fullname.localeCompare(b.fullname)
    );

    return (
      <Grommet theme={printTheme}>
        <Box
          style={{
            width: "297mm", // A4 landscape width
            minHeight: "210mm", // A4 landscape height
            padding: "10mm",
            margin: "0 auto",
            backgroundColor: "white",
            fontSize: "10px",
            fontFamily: "Arial, sans-serif",
          }}
        >
          {/* Header */}
          <Box align="center" margin={{ bottom: "medium" }}>
            <Text size="large" weight="bold">
              Customer List
            </Text>
            <Text size="small">
              Printed on: {new Date().toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit', 
                year: 'numeric'
              })}
            </Text>
          </Box>

          {/* Table */}
          <Box>
            {/* Table Header */}
            <Box
              direction="row"
              style={{
                borderTop: "1px solid #000",
                borderBottom: "1px solid #000",
                backgroundColor: "#f5f5f5",
                padding: "4px 2px",
                fontSize: "9px",
                fontWeight: "bold",
              }}
            >
              <Box width="3%" style={{ borderRight: "1px solid #ccc", paddingRight: "2px" }}>
                <Text size="9px" weight="bold">No.</Text>
              </Box>
              <Box width="12%" style={{ borderRight: "1px solid #ccc", paddingLeft: "2px", paddingRight: "2px" }}>
                <Text size="9px" weight="bold">Full Name</Text>
              </Box>
              <Box width="10%" style={{ borderRight: "1px solid #ccc", paddingLeft: "2px", paddingRight: "2px" }}>
                <Text size="9px" weight="bold">Contact Person</Text>
              </Box>
              <Box width="10%" style={{ borderRight: "1px solid #ccc", paddingLeft: "2px", paddingRight: "2px" }}>
                <Text size="9px" weight="bold">Phone</Text>
              </Box>
              <Box width="12%" style={{ borderRight: "1px solid #ccc", paddingLeft: "2px", paddingRight: "2px" }}>
                <Text size="9px" weight="bold">Email</Text>
              </Box>
              <Box width="15%" style={{ borderRight: "1px solid #ccc", paddingLeft: "2px", paddingRight: "2px" }}>
                <Text size="9px" weight="bold">Address</Text>
              </Box>
              <Box width="8%" style={{ borderRight: "1px solid #ccc", paddingLeft: "2px", paddingRight: "2px" }}>
                <Text size="9px" weight="bold">Province</Text>
              </Box>
              <Box width="8%" style={{ borderRight: "1px solid #ccc", paddingLeft: "2px", paddingRight: "2px" }}>
                <Text size="9px" weight="bold">City</Text>
              </Box>
              <Box width="8%" style={{ borderRight: "1px solid #ccc", paddingLeft: "2px", paddingRight: "2px" }}>
                <Text size="9px" weight="bold">Salesman</Text>
              </Box>
              <Box width="7%" style={{ borderRight: "1px solid #ccc", paddingLeft: "2px", paddingRight: "2px" }}>
                <Text size="9px" weight="bold">Zone</Text>
              </Box>
              <Box width="7%" style={{ borderRight: "1px solid #ccc", paddingLeft: "2px", paddingRight: "2px" }}>
                <Text size="9px" weight="bold">Courier</Text>
              </Box>
              <Box width="7%" style={{ paddingLeft: "2px" }}>
                <Text size="9px" weight="bold">Accurate</Text>
              </Box>
            </Box>

            {/* Table Body */}
            {sortedCustomers.map((customer, index) => (
              <Box
                key={customer.id_customer}
                direction="row"
                style={{
                  borderBottom: "1px solid #ccc",
                  padding: "3px 2px",
                  fontSize: "8px",
                  minHeight: "18px",
                }}
              >
                <Box width="3%" style={{ borderRight: "1px solid #ccc", paddingRight: "2px" }}>
                  <Text size="8px">{index + 1}</Text>
                </Box>
                <Box width="12%" style={{ borderRight: "1px solid #ccc", paddingLeft: "2px", paddingRight: "2px" }}>
                  <Text size="8px">{customer.fullname || '-'}</Text>
                </Box>
                <Box width="10%" style={{ borderRight: "1px solid #ccc", paddingLeft: "2px", paddingRight: "2px" }}>
                  <Text size="8px">{customer.contact_person || '-'}</Text>
                </Box>
                <Box width="10%" style={{ borderRight: "1px solid #ccc", paddingLeft: "2px", paddingRight: "2px" }}>
                  <Text size="8px">{customer.phone || '-'}</Text>
                </Box>
                <Box width="12%" style={{ borderRight: "1px solid #ccc", paddingLeft: "2px", paddingRight: "2px" }}>
                  <Text size="8px">{customer.email || '-'}</Text>
                </Box>
                <Box width="15%" style={{ borderRight: "1px solid #ccc", paddingLeft: "2px", paddingRight: "2px" }}>
                  <Text size="8px">
                    {customer.up_address && customer.up_address.length > 0 
                      ? customer.up_address[0].street || '-' 
                      : '-'}
                  </Text>
                </Box>
                <Box width="8%" style={{ borderRight: "1px solid #ccc", paddingLeft: "2px", paddingRight: "2px" }}>
                  <Text size="8px">
                    {customer.up_address && customer.up_address.length > 0 
                      ? customer.up_address[0].province || '-' 
                      : '-'}
                  </Text>
                </Box>
                <Box width="8%" style={{ borderRight: "1px solid #ccc", paddingLeft: "2px", paddingRight: "2px" }}>
                  <Text size="8px">
                    {customer.up_address && customer.up_address.length > 0 
                      ? customer.up_address[0].city || '-' 
                      : '-'}
                  </Text>
                </Box>
                <Box width="8%" style={{ borderRight: "1px solid #ccc", paddingLeft: "2px", paddingRight: "2px" }}>
                  <Text size="8px">
                    {customer.up_salesman ? customer.up_salesman.salesman : '-'}
                  </Text>
                </Box>
                <Box width="7%" style={{ borderRight: "1px solid #ccc", paddingLeft: "2px", paddingRight: "2px" }}>
                  <Text size="8px">
                    {customer.up_zone ? customer.up_zone.zone : '-'}
                  </Text>
                </Box>
                <Box width="7%" style={{ borderRight: "1px solid #ccc", paddingLeft: "2px", paddingRight: "2px" }}>
                  <Text size="8px">
                    {customer.up_courier ? customer.up_courier.courier : '-'}
                  </Text>
                </Box>
                <Box width="7%" style={{ paddingLeft: "2px" }}>
                  <Text size="8px">{customer.customer_accurate || '-'}</Text>
                </Box>
              </Box>
            ))}
          </Box>

          {/* Footer */}
          <Box align="center" margin={{ top: "medium" }}>
            <Text size="small">
              Total: {sortedCustomers.length} customers
            </Text>
          </Box>
        </Box>

        <style>
          {`
            @media print {
              @page {
                size: A4 landscape;
                margin: 0.5in;
              }
              body { 
                margin: 0; 
                font-size: 8px !important;
              }
              .no-print { 
                display: none; 
              }
            }
          `}
        </style>
      </Grommet>
    );
  }
}

export default PrintCustomerList;
